/* @flow */
import { emailValidator, passwordValidator } from './';

const submitLogin = (
  email: String,
  password: String,
  informaOnly: Boolean,
  login: Function,
  ) => {

  const validation =
    emailValidator(email, informaOnly) && passwordValidator(password);

  if (validation) {
    login(email, password);
  }
};

export default submitLogin;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/enhancers/validators/submitLogin.js
 **/